export enum GunStatusColorEnum {
  /**
   * 空闲
   */
  free = 7,
  /**
   * 插抢
   */
  putGun = 1,
  /**
   * 充满
   */
  full = 8,
  /**
   * 充电
   */
  charge = 0,
  /**
   *离线
   */
  offline = 4,
  /**
   * 故障
   */
  fault = 2,
  /**
   * 禁用
   */
  forbidden = 3,
  /**
   * 预约
   */
  order = 9
}

export enum PileStatusEnum {
  /**
   * 交流桩
   */
  pileAc = 2,
  /**
   * 直流桩
   */
  pileDc = 3
}
